
import { defineComponent } from "vue";
export default defineComponent({
  components: {},
  props: { message: { type: String, default: "" } },
  setup: () => {
    /**
     * 動的ラベル
     */
    const loadingGif = "../public/loading.svg" //"../public/gif-load.gif";
    return {
      loadingGif,
    };
  },
});
